import React from 'react'
import { Button } from '@material-ui/core'

export default function CustomFilterButtons({ onFilter, source }) {

    return (
        <>
            <div className="d-flex justify-content-center gap-2">
                <Button 
                    size="small" 
                    className={"bs-bg-invert bs-color-b "+ (source === 'all' && 'btn-checked')}
                    variant="contained" 
                    color="primary"
                    onClick={() => {
                        onFilter({
                            source: 'all'
                        })
                    }}
                >
                    Tudo
                </Button>
                <Button 
                    size="small"  
                    className={"bs-bg-invert bs-color-b "+ (source === 'admin' && 'btn-checked')}
                    variant="contained" 
                    color="primary"
                    onClick={() => {
                        onFilter({
                            source: 'admin'
                        })
                    }}
                >
                    Admin
                </Button>

                <Button 
                    size="small"  
                    className={"bs-bg-invert bs-color-b "+ (source === 'gestor' && 'btn-checked')}
                    variant="contained" 
                    color="primary"
                    onClick={() => {
                        onFilter({
                            source: 'gestor'
                        })
                    }}
                >
                    Gestor
                </Button>


                <Button
                    size="small"  
                    className={"bs-bg-invert bs-color-b "+ (source === 'afiliado' && 'btn-checked')}
                    variant="contained" 
                    color="primary"
                    onClick={() => {
                        onFilter({
                            source: 'afiliado'
                        })
                    }}
                >
                    Afiliado
                </Button>
            </div>
        </>
    )
}